module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "ui center aligned header"
  }, [_vm._v("Find your verb")]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui icon massive input loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_field),
      expression: "search_field"
    }],
    staticClass: "search loading",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_field)
    },
    on: {
      "keyup": function($event) {
        _vm.is_search = false
      },
      "keydown": function($event) {
        _vm.is_search = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_field = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.is_search) ? _c('i', {
    staticClass: "search icon"
  }) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredVerbs), function(item) {
    return _c('table-item', {
      key: item.base_form,
      attrs: {
        "items": item
      }
    })
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Base form")]), _vm._v(" "), _c('th', [_vm._v("Past Simple (V2)")]), _vm._v(" "), _c('th', [_vm._v("Past Participle (V3)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64fc3e8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableContent.vue
// module id = 12
// module chunks = 0